import React, { Fragment, useState, useEffect, useRef } from 'react';
import { H6, P } from '../../../AbstractElements';
import { Card, Col, CardBody, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import i18n from '../../../i18n';
import TicketPhotoGallery from '../../../Components/TicketPhotoGallery';
import { fetchData } from './searchData';
import { normalizePlateSearch } from '../../../utils/plateSearch';
import { sortPlateIndexEntriesNewestFirst } from '../../../utils/ticketPlateIndex';


const SearchResults = (props) => {

    const [resultsArray, setResultsArray] = useState([]);
    const [results, setResults] = useState(new Map());
    const [view, setView] = useState('nosearch');
    const [visibleCount, setVisibleCount] = useState(25);
    const latestSearchRequest = useRef(0);
    const searching = props.searching || '';
    const normalizedSearchTerm = searching.toLowerCase().replaceAll(" ", "").replaceAll("/", "-");

    const applyResults = (data) => {
        const resultsMap = data || new Map();
        console.time("[plate-search] render data prepared");
        const newList = sortPlateIndexEntriesNewestFirst(Array.from(resultsMap.entries(), ([id, ticket]) => ({ ...ticket, ticketid: id })))
            .map(ticket => ticket.ticketid);
        setResults(resultsMap);
        props.searchResult(newList);
        setResultsArray(newList);
        console.timeEnd("[plate-search] render data prepared");
    };

    useEffect(() => {
        let isMounted = true;
        const requestId = latestSearchRequest.current + 1;
        latestSearchRequest.current = requestId;

        if (isMounted) {
            if (props.searching && props.searching !== '') {
                setResults(new Map());
                setVisibleCount(25);
                setResultsArray([]);
                props.searchResult([]);
                setView('sending');

                fetchData(props.searching, {
                    preferFast: true,
                    skipCache: true,
                    onError: () => {
                        if (isMounted && latestSearchRequest.current === requestId) setView('error');
                    },
                    onUpdate: (data) => {
                        if (!isMounted || latestSearchRequest.current !== requestId) {
                            return;
                        }

                        applyResults(data);
                        setView('success');
                    },
                }).then((data) => {
                    if (!isMounted || latestSearchRequest.current !== requestId) {
                        return;
                    }

                    applyResults(data);
                    setView('success');
                }).catch((error) => {
                    console.error('Search failed', error);

                    if (!isMounted || latestSearchRequest.current !== requestId) {
                        return;
                    }

                    const emptyResults = new Map();
                    setResults(emptyResults);
                    props.searchResult([]);
                    setResultsArray([]);
                    setView('error');
                });

            } else {

                setResults(new Map());
                setResultsArray([]);
                props.searchResult([]);
                setView('nosearch');
            }

        }

        return () => {
            isMounted = false;
        };

    }, [props.searching, props.searchResult]);



    const setSearchFocus = () => {
        console.log("setFocus");
    };

    const searchView = () => {
        switch (view) {
            // 'form': return formView;
            case 'nosearch': return noSearchView;
            case 'sending': return sendingView;
            case 'success': return null;
            case 'error': return <p role="alert">La recherche n’a pas pu être complétée. Veuillez réessayer.</p>;
            default: return noSearchView
        }
    }


    const noSearchView =
        <Card className="br-15">
            <CardBody className="text-center">
                <h5 className="text-center f-color-fadedgray"> {!results ? i18n.t('Admin_SearchPage_SearchResults_No_Search_Title_Txt') : i18n.t('Admin_SearchPage_SearchResults_No_Results_Title_Txt')} </h5>
                <button className='btn btn-fadedgray btn-lg m-t-20 p-t-15 p-b-15' onClick={setSearchFocus} >{i18n.t('Admin_SearchPage_SearchResults_Start_Search_Btn')}</button>
            </CardBody>
        </Card>

    const sendingView =
        <Card className="br-15">
            <p className='p-t-30 text-center text-bold'>Recherche en cours... ne pas quitter la page s.v.p. <br /></p>
            <p className='p-t-0 text-center'>Recherche : {props.searching}  </p>
            <div className={`loader-box loading-paymodal`}>

                <div className='loader-container paymodal-loading-container m-b-40'>
                    <div className='loader-box paymodal-loader-box'>
                        <div className='paycard-loader'></div>
                    </div>
                </div>
            </div>
        </Card>;

    return (
        <Fragment>



            <Col md="12 m-b-40 search-page">

                <Row>
                    <p className="pb-4">{`Environs ${resultsArray.length} .... résultats trouvé(s)`}</p>
                    {resultsArray.slice(0, visibleCount).map(id => {
                        const result = results.get(id) || {};
                        const ticketId = String(result.ticketid || result.ticketId || id);
                        const carplate = result.carplate || result.plate || '';
                        const carbrand = result.carbrand || result.make || '';
                        const carmodel = result.carmodel || result.model || '';
                        const contract = result.contract || result.unit || '';
                        const address = result.address || result.location || '';

                        return (

                        <Col md="4" key={id} s="12">

                            <Card className={`br-15`}>

                                <div className="txt-search p-20">

                                    <div className="media">
                                        <span className="hideOverflow">
                                            <TicketPhotoGallery ticket={result} imageClassName="img-search img-fluid" />
                                        </span>
                                        <div className="media-body">
                                            <H6 attrH6={{ className: 'f-w-600' }} >

                                                <Link to={`${process.env.PUBLIC_URL}/dashboard/avis/` + ticketId}>
                                                    {ticketId.includes(normalizedSearchTerm) ?
                                                        <span className="searchmark">{ticketId}</span>
                                                        : ticketId
                                                    }

                                                </Link>
                                                {(result.time || '').replaceAll("/", "-").includes(normalizedSearchTerm) ?
                                                    <span className="pull-right f-12 searchmark">{result.time}</span>
                                                    : <span className="pull-right f-12">{result.time}</span>
                                                }

                                                {(result.date || '').replaceAll("/", "-").includes(normalizedSearchTerm) ?
                                                    <span className="pull-right f-12 searchmark">{result.date}</span>
                                                    : <span className="pull-right f-12">{result.date}</span>
                                                }
                                                <br />



                                                <span className="pull-right f-12 text-capitalized">{normalizePlateSearch(carplate).includes(normalizePlateSearch(props.searching)) ?

                                                    <span className="searchmark">{carplate.replaceAll(" ", "").replaceAll("-", "")}</span>
                                                    : carplate.replaceAll(" ", "").replaceAll("-", "")
                                                }
                                                </span>


                                            </H6>
                                            <P>
                                                {carbrand.toLowerCase().replaceAll("-", "").includes(normalizedSearchTerm) ?
                                                    <span className="searchmark">{carbrand}</span>
                                                    : carbrand
                                                }
                                                ,
                                                {carmodel.toLowerCase().replaceAll("-", "").includes(normalizedSearchTerm) ?
                                                    <span className="searchmark">{carmodel}</span>
                                                    : carmodel
                                                }
                                            </P><br />

                                            <P>
                                                <span className="f-12 text-capitalized">{contract.replaceAll(" ", "").replaceAll("-", "").toLowerCase().includes(props.searching.toLowerCase().replaceAll(" ", "")) ?

                                                    <span className="searchmark">{contract}</span>
                                                    : contract

                                                } </span>
                                                <br />
                                                <span className="f-12 text-capitalized">{address.replaceAll(" ", "").replaceAll("-", "").toLowerCase().includes(props.searching.toLowerCase().replaceAll(" ", "")) ?

                                                    <span className="searchmark">{address}</span>
                                                    : address
                                                }
                                                </span>
                                            </P>



                                        </div>

                                    </div>


                                </div>

                            </Card>
                        </Col>

                    )})}

                </Row>
                {visibleCount < resultsArray.length && (
                    <button type="button" className="btn btn-primary" onClick={() => setVisibleCount(count => count + 25)}>
                        Voir plus de résultats ({Math.min(visibleCount, resultsArray.length)} / {resultsArray.length})
                    </button>
                )}
            </Col>


            <Col md="12 m-b-40">
                {searchView()}
            </Col>


        </Fragment >
    );
};

export default SearchResults;
